"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "arrayBufferToBase64", {
  enumerable: true,
  get: function get() {
    return _base64Helpers.arrayBufferToBase64;
  }
});
Object.defineProperty(exports, "base64ToArray", {
  enumerable: true,
  get: function get() {
    return _base64Helpers.base64ToArray;
  }
});
Object.defineProperty(exports, "base64ToText", {
  enumerable: true,
  get: function get() {
    return _base64Helpers.base64ToText;
  }
});
Object.defineProperty(exports, "byteArrayToBase64", {
  enumerable: true,
  get: function get() {
    return _base64Helpers.byteArrayToBase64;
  }
});
Object.defineProperty(exports, "decodeBase64Attachment", {
  enumerable: true,
  get: function get() {
    return _attachment.decodeBase64Attachment;
  }
});
Object.defineProperty(exports, "encodeBase64Attachment", {
  enumerable: true,
  get: function get() {
    return _attachment2.encodeBase64Attachment;
  }
});
Object.defineProperty(exports, "getAttachmentValues", {
  enumerable: true,
  get: function get() {
    return _getAttachmentValues.getAttachmentValues;
  }
});
Object.defineProperty(exports, "isAttachment", {
  enumerable: true,
  get: function get() {
    return _attachment.isAttachment;
  }
});
Object.defineProperty(exports, "stringToUtf8Bytes", {
  enumerable: true,
  get: function get() {
    return _base64Helpers.stringToUtf8Bytes;
  }
});
var _attachment = require("./attachment.decode");
var _attachment2 = require("./attachment.encode");
var _base64Helpers = require("./base64Helpers");
var _getAttachmentValues = require("./getAttachmentValues");